import Vue from 'vue'
import { Line, Bar, Doughnut } from 'vue-chartjs/legacy'

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  BarElement,
  CategoryScale,
  LinearScale,
  LineElement,
  PointElement,
  Filler
} from 'chart.js'

ChartJS.register(
  Title,
  Filler,
  Tooltip,
  Legend,
  PointElement,
  ArcElement,
  BarElement,
  CategoryScale,
  LinearScale,
  LineElement
)

Vue.component('line-chart', {
  extends: Line
})

Vue.component('bar-chart', {
  extends: Bar
})

Vue.component('doughnut-chart', {
  extends: Doughnut
})
